import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Crawler snapshots (edge "crawler-cache") already contain the rendered head tags; drop them so the
// client render doesn't duplicate title/canonical/robots/OG/Twitter/JSON-LD. Static index.html tags are kept.
document.head
  .querySelectorAll(
    'title, meta[name="description"], meta[name="keywords"], meta[name="robots"], link[rel="canonical"], ' +
      'meta[property^="og:"], meta[name^="twitter:"], script[type="application/ld+json"]:not([data-static])',
  )
  .forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
